import IconTreeArrowDown from '@bimser/icons/16/tree-arrow-down';
import { Button, DropdownProps } from 'antd';
import BCDivider from '../BCDivider';
import { IButtonOverflowItem } from './entities/IButtonOverflowItem';
import { ItemWrapper } from './ItemWrapper';
import { OverflowButtons } from './OverflowButtons';

const ButtonList: React.FC<{
	items: IButtonOverflowItem[];
	measureMode?: boolean;
	dropdownProps?: DropdownProps;
}> = props => {
	if (!props.items.length) return null;

	const renderItem = (item: IButtonOverflowItem) => {
		if (item.onRender) {
			return (
				<div
					key={item.key}
					style={{ display: 'inline-block' }}
				>
					{item.onRender(item)}
				</div>
			);
		}

		if (item.type === 'divider') {
			return (
				<BCDivider
					key={item.key}
					type="vertical"
				/>
			);
		}

		const onButtonClick: React.MouseEventHandler<HTMLElement> = e => {
			if (item.buttonProps?.onClick) {
				item.buttonProps.onClick(e, item);
			}
		};

		if (item.items?.length) {
			return (
				<OverflowButtons
					key={item.key}
					items={item.items}
					dropdownProps={props.dropdownProps}
				>
					<Button
						{...item.buttonProps}
						onClick={onButtonClick}
					>
						{item.buttonProps.children}
						<IconTreeArrowDown />
					</Button>
				</OverflowButtons>
			);
		}

		return (
			<Button
				key={item.key}
				{...item.buttonProps}
				onClick={onButtonClick}
			/>
		);
	};

	return (
		<>
			{props.items.map(item =>
				props.measureMode ? (
					<ItemWrapper key={item.key}>{renderItem(item)}</ItemWrapper>
				) : (
					renderItem(item)
				)
			)}
		</>
	);
};

export { ButtonList };
